import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels'

export const SplitterGroup = PanelGroup
export const SplitterPanel = Panel
export const SplitterResizeHandle = PanelResizeHandle

export { default as splitterTheme } from '#react/theme/splitter'
